<template>
    <div v-if="loaded" class="course-location__item">
       <div v-if="data.day" class="course-location__item-day">{{  data.day }}</div>
       <div v-if="data.subject">{{  data.subject }}</div>
       <div v-if="data.starttime" class="course-location__item-time"><Icon name="clock" />{{  data.starttime }} - {{  data.endtime }}</div>
       <div v-if="data.date" class="course-location__item-date"><Icon name="calendar" />{{  data.date }}</div>
    </div>
</template>

<script>
import Icon from './Icon.vue';

export default {
    name: 'CourseLocationItem',
    data() {
        return {
            loaded: false,
        };
    },
    props: ['data'],
    components: {
        Icon
    },
    mounted: function() {
        this.loaded = true;
    }
};
</script>